import { render } from "./table.vue?vue&type=template&id=fafc8a58&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=fafc8a58&lang=scss"
import "./table.vue?vue&type=style&index=1&id=fafc8a58&scoped=true&lang=scss"
import "./table.vue?vue&type=style&index=2&id=fafc8a58&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fafc8a58"]])

export default __exports__